type StateUnionType = "initial" | "loading" | "success" | "error"

type SelectOptionType = {
    label: string,
    value: any
}

type SelectComponentProps = {
    name: string,
    label?: string,
    value: any,
    data: SelectOptionType[],
    state: StateUnionType,
    isDisabled?: boolean,
    altDefaultOption?: SelectOptionType,
    isDefaultSelectable?: boolean
    onSelectOption: (name: string, value: any) => any,
    isRequired?: boolean
}

type TSelectComponentStates = {
    [key: string]: StateUnionType
}

export type {
    TSelectComponentStates,
    SelectComponentProps,
    SelectOptionType,
    StateUnionType
};

export const handleClick = (ref: any, value: any, setValue: any) => {
    if (ref) {
        if (!value) {
            const end = ref.value.length;
            ref.setSelectionRange(end, end);
            ref.focus();
            
        } else {
            ref.blur();
        }
        setValue(!value);
    }
}
